const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

/** Split a display name into first / last (space-separated). */
export const splitDisplayName = (name = "") => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return { first: "", last: "" };
  if (parts.length === 1) return { first: parts[0], last: "" };
  return { first: parts[0], last: parts.slice(1).join(" ") };
};

/**
 * Resolve firstname / lastname the same way everywhere.
 * Prefer explicit IAM fields; else split `name` when it is a real display name
 * (not equal to username); else fall back to name/username in firstname.
 */
export const resolveUserNames = (sourceInput) => {
  const source =
    sourceInput && typeof sourceInput === "object" ? sourceInput : {};
  const username = String(
    firstDefined(source.username, source.userName, "") || ""
  ).trim();
  const rawName = String(source.name || "").trim();
  const nameIsUsername =
    Boolean(rawName) &&
    Boolean(username) &&
    rawName.toLowerCase() === username.toLowerCase();

  const fromName = nameIsUsername
    ? { first: "", last: "" }
    : splitDisplayName(rawName);

  let firstname =
    firstDefined(source.firstname, source.firstName, fromName.first) || "";
  let lastname =
    firstDefined(source.lastname, source.lastName, fromName.last) || "";

  if (!firstname && !lastname) {
    firstname = firstDefined(rawName, username) || "";
  }

  const namesFromIam = Boolean(
    firstDefined(
      source.firstname,
      source.firstName,
      source.lastname,
      source.lastName
    )
  );

  return {
    username: username || firstDefined(rawName, firstname, "") || "",
    displayName:
      [firstname, lastname].filter(Boolean).join(" ").trim() ||
      firstDefined(rawName, username) ||
      "",
    firstname,
    lastname,
    namesFromIam,
  };
};
